// readonly Access_Functions = Access_Functions;
export const Access_Functions = {
    CUSTOMER_FULFILMENT_GRAPH_READ: 'CUSTOMER_FULFILMENT_GRAPH_READ',
    CUSTOMER_PARCEL_GRAPH_READ: 'CUSTOMER_PARCEL_GRAPH_READ',
    CUSTOMER_SHIPMENT_GRAPH_READ: 'CUSTOMER_SHIPMENT_GRAPH_READ',
    CUSTOMER_PRODUCT_GRAPH_READ: 'CUSTOMER_PRODUCT_GRAPH_READ',
    CUSTOMER_INVENTORY_GRAPH_READ: 'CUSTOMER_INVENTORY_GRAPH_READ',
    INVENTORY_PRODUCT_READ: 'INVENTORY_PRODUCT_READ',
    INVENTORY_PRODUCT_WRITE: 'INVENTORY_PRODUCT_WRITE',
    KIT_PRODUCT_READ: 'KIT_PRODUCT_READ',
    KIT_PRODUCT_WRITE: 'KIT_PRODUCT_WRITE',
    INVENTORY_BULK_ACTIVITY_READ: 'INVENTORY_BULK_ACTIVITY_READ',
    INVENTORY_BULK_ACTIVITY_WRITE: 'INVENTORY_BULK_ACTIVITY_WRITE',
    INVENTORY_CHANNEL_PRODUCT_READ: 'INVENTORY_CHANNEL_PRODUCT_READ',
    INVENTORY_CHANNEL_PRODUCT_WRITE: 'INVENTORY_CHANNEL_PRODUCT_WRITE',
    INVENTORY_PRODUCT_BOOK_READ: 'INVENTORY_PRODUCT_BOOK_READ',
    INVENTORY_PRODUCT_BOOK_WRITE: 'INVENTORY_PRODUCT_BOOK_WRITE',
    INVENTORY_UNSYNC_PRODUCT_READ: 'INVENTORY_UNSYNC_PRODUCT_READ',
    INVENTORY_UNSYNC_PRODUCT_WRITE: 'INVENTORY_UNSYNC_PRODUCT_WRITE',
    INVENTORY_BRAND_READ: 'INVENTORY_BRAND_READ',
    INVENTORY_BRAND_WRITE: 'INVENTORY_BRAND_WRITE',
    MANAGE_SUPPLIER_READ: 'MANAGE_SUPPLIER_READ',
    MANAGE_SUPPLIER_WRITE: 'MANAGE_SUPPLIER_WRITE',
    SUPPLIER_BULK_ACTIVITY_READ: 'SUPPLIER_BULK_ACTIVITY_READ',
    SUPPLIER_BULK_ACTIVITY_WRITE: 'SUPPLIER_BULK_ACTIVITY_WRITE',
    DRAFT_ORDER_READ: 'DRAFT_ORDER_READ',
    DRAFT_ORDER_WRITE: 'DRAFT_ORDER_WRITE',
    CONFIRMED_ORDER_READ: 'CONFIRMED_ORDER_READ',
    CONFIRMED_ORDER_WRITE: 'CONFIRMED_ORDER_WRITE',
    SUCCESSFUL_ORDER_READ: 'SUCCESSFUL_ORDER_READ',
    SUCCESSFUL_ORDER_WRITE: 'SUCCESSFUL_ORDER_WRITE',
    RETURN_ORDER_READ: 'RETURN_ORDER_READ',
    RETURN_ORDER_WRITE: 'RETURN_ORDER_WRITE',
    MARKETPLACE_ORDER_READ: 'MARKETPLACE_ORDER_READ',
    MARKETPLACE_ORDER_WRITE: 'MARKETPLACE_ORDER_WRITE',
    ECOMMERCE_ORDER_READ: 'ECOMMERCE_ORDER_READ',
    ECOMMERCE_ORDER_WRITE: 'ECOMMERCE_ORDER_WRITE',
    ORDER_BULK_ACTIVITY_READ: 'ORDER_BULK_ACTIVITY_READ',
    ORDER_BULK_ACTIVITY_WRITE: 'ORDER_BULK_ACTIVITY_WRITE',
    ORDER_ACTION_REQUIRED_READ: 'ORDER_ACTION_REQUIRED_READ',
    ORDER_ACTION_REQUIRED_WRITE: 'ORDER_ACTION_REQUIRED_WRITE',
    // order capabilities the seller login sends (not used by the app yet)
    OFFLINE_ORDER_EDIT: 'OFFLINE_ORDER_EDIT',
    ONLINE_ORDER_EDIT: 'ONLINE_ORDER_EDIT',
    ORDER_INVOICE: 'ORDER_INVOICE',
    ORDER_PICK_LIST: 'ORDER_PICK_LIST',
    // JDL seller (JDL_NF_CUSTOMER role, OEM-7398): a service is mapped by carrier only,
    // with no DPD Product Type and no Product
    SERVICE_ONLY_MAPPING: 'SERVICE_ONLY_MAPPING',
    // Jingdong (JDL), held by the JDL_NF_CUSTOMER seller role (backend, OEM-7340).
    // PD_CODE_READ: the PD code of an order and the dropdown / bulk assign APIs;
    // PD_CODE_WRITE: the PD code is mandatory on a new shipment order and may be sent.
    PD_CODE_READ: 'PD_CODE_READ',
    PD_CODE_WRITE: 'PD_CODE_WRITE',
    SALES_PLATFORM_CODE_READ: 'SALES_PLATFORM_CODE_READ',
    SALES_PLATFORM_CODE_WRITE: 'SALES_PLATFORM_CODE_WRITE',
    REMORSE_PERIOD_READ: 'REMORSE_PERIOD_READ',
    REMORSE_PERIOD_WRITE: 'REMORSE_PERIOD_WRITE',
    ORDER_BLOCK_ORDERS_READ: 'ORDER_BLOCK_ORDERS_READ',
    ORDER_BLOCK_ORDERS_WRITE: 'ORDER_BLOCK_ORDERS_WRITE',
    ORDER_PARCEL_READ: 'ORDER_PARCEL_READ',
    ORDER_PARCEL_WRITE: 'ORDER_PARCEL_WRITE',
    INBOUND_CONSIGNMENT_READ: 'INBOUND_CONSIGNMENT_READ',
    INBOUND_CONSIGNMENT_WRITE: 'INBOUND_CONSIGNMENT_WRITE',
    INBOUND_GOODS_RECEIVED_READ: 'INBOUND_GOODS_RECEIVED_READ',
    INBOUND_GOODS_RECEIVED_WRITE: 'INBOUND_GOODS_RECEIVED_WRITE',
    INBOUND_BULK_ACTIVITY_READ: 'INBOUND_BULK_ACTIVITY_READ',
    INBOUND_BULK_ACTIVITY_WRITE: 'INBOUND_BULK_ACTIVITY_WRITE',
    MANAGE_REPORT_READ: 'MANAGE_REPORT_READ',
    MANAGE_REPORT_WRITE: 'MANAGE_REPORT_WRITE',
    INTEGRATION_MARKETPLACE_READ: 'INTEGRATION_MARKETPLACE_READ',
    INTEGRATION_MARKETPLACE_WRITE: 'INTEGRATION_MARKETPLACE_WRITE',
    CUSTOMER_CONFIG_CARRIER_STORE_READ: 'CUSTOMER_CONFIG_CARRIER_STORE_READ',
    CUSTOMER_CONFIG_CARRIER_STORE_WRITE: 'CUSTOMER_CONFIG_CARRIER_STORE_WRITE',
    THIRD_PARTY_LOGISTIC_READ: 'THIRD_PARTY_LOGISTIC_READ',
    THIRD_PARTY_LOGISTIC_WRITE: 'THIRD_PARTY_LOGISTIC_WRITE',
    CUSTOMER_CONFIG_BULK_ACTIVITY_READ: 'CUSTOMER_CONFIG_BULK_ACTIVITY_READ',
    CUSTOMER_CONFIG_BULK_ACTIVITY_WRITE: 'CUSTOMER_CONFIG_BULK_ACTIVITY_WRITE',
    CUSTOMER_CONFIG_ECOMMERCE_READ: 'CUSTOMER_CONFIG_ECOMMERCE_READ',
    CUSTOMER_CONFIG_ECOMMERCE_WRITE: 'CUSTOMER_CONFIG_ECOMMERCE_WRITE',
    CUSTOMER_CONFIG_SERVICE_MAPPING_READ:
        'CUSTOMER_CONFIG_SERVICE_MAPPING_READ',
    CUSTOMER_CONFIG_SERVICE_MAPPING_WRITE:
        'CUSTOMER_CONFIG_SERVICE_MAPPING_WRITE',
    CUSTOMER_CONFIG_PRINTER_SETUP_READ: 'CUSTOMER_CONFIG_PRINTER_SETUP_READ',
    CUSTOMER_CONFIG_PRINTER_SETUP_WRITE: 'CUSTOMER_CONFIG_PRINTER_SETUP_WRITE',
    CUSTOMER_CONFIG_DEFAULT_PARAMS_READ: 'CUSTOMER_CONFIG_DEFAULT_PARAMS_READ',
    CUSTOMER_CONFIG_DEFAULT_PARAMS_WRITE:
        'CUSTOMER_CONFIG_DEFAULT_PARAMS_WRITE',
    MY_INFORMATION_READ: 'MY_INFORMATION_READ',
    MY_INFORMATION_WRITE: 'MY_INFORMATION_WRITE',
    CUSTOMER_USER_MANAGEMENT_READ: 'CUSTOMER_USER_MANAGEMENT_READ',
    CUSTOMER_USER_MANAGEMENT_WRITE: 'CUSTOMER_USER_MANAGEMENT_WRITE',
    DISPATCH_NOTE_READ: 'DISPATCH_NOTE_READ',
    DISPATCH_NOTE_WRITE: 'DISPATCH_NOTE_WRITE',
    CUSTOMER_CONFIG_LABEL_FORMAT_READ: 'CUSTOMER_CONFIG_LABEL_FORMAT_READ',
    CUSTOMER_CONFIG_LABEL_FORMAT_WRITE: 'CUSTOMER_CONFIG_LABEL_FORMAT_WRITE',
    CUSTOMER_CONFIG_SSO_READ: 'CUSTOMER_CONFIG_SSO_READ',
    CUSTOMER_CONFIG_SSO_WRITE: 'CUSTOMER_CONFIG_SSO_WRITE',
    SSO_CONFIG_READ: 'SSO_CONFIG_READ',
    SSO_CONFIG_WRITE: 'SSO_CONFIG_WRITE',
    ORDER_UNSYNC_READ: 'ORDER_UNSYNC_READ',
    ORDER_UNSYNC_WRITE: 'ORDER_UNSYNC_WRITE',
    INTEGRATION_PACKING_SLIP_READ: 'INTEGRATION_PACKING_SLIP_READ',
    INTEGRATION_PACKING_SLIP_WRITE: 'INTEGRATION_PACKING_SLIP_WRITE'
    // TODO: restore when backend emits these permissions
    // CUSTOMER_ADDRESS_BOOK_READ: 'CUSTOMER_ADDRESS_BOOK_READ',
    // CUSTOMER_ADDRESS_BOOK_WRITE: 'CUSTOMER_ADDRESS_BOOK_WRITE'
};
